// extracted by mini-css-extract-plugin
module.exports = {"general":"NotifyPopup_general__fJTCX","success":"NotifyPopup_success__tAgl3","warning":"NotifyPopup_warning__ntk8g"};